"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationBetween = exports.DifferenceBetween = exports.doBefore = exports.doAfter = exports.TimezoneOffsetFrom = exports.TimeFrom = exports.DateFrom = exports.DateTimeComponentFrom = exports.TimeOfDay = exports.Now = exports.Today = exports.Time = exports.Date = exports.DateTime = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var literal_1 = require("./literal");
var DT = __importStar(require("../datatypes/datatypes"));
var DateTime = /** @class */ (function (_super) {
    __extends(DateTime, _super);
    function DateTime(json) {
        var _this = _super.call(this, json) || this;
        _this.json = json;
        return _this;
    }
    DateTime.prototype.exec = function (ctx) {
        var _a;
        var _this = this;
        for (var _i = 0, _b = DateTime.PROPERTIES; _i < _b.length; _i++) {
            var property = _b[_i];
            // if json does not contain 'timezoneOffset' set it to the executionDateTime from the context
            if (this.json[property] != null) {
                // @ts-ignore
                this[property] = (0, builder_1.build)(this.json[property]);
            }
            else if (property === 'timezoneOffset' && ctx.getTimezoneOffset() != null) {
                // @ts-ignore
                this[property] = literal_1.Literal.from({
                    type: 'Literal',
                    value: ctx.getTimezoneOffset(),
                    valueType: '{urn:hl7-org:elm-types:r1}Integer'
                });
            }
        }
        // @ts-ignore
        var args = DateTime.PROPERTIES.map(function (p) { return (_this[p] != null ? _this[p].execute(ctx) : undefined); });
        return new ((_a = DT.DateTime).bind.apply(_a, __spreadArray([void 0], args, false)))();
    };
    DateTime.PROPERTIES = [
        'year',
        'month',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
        'timezoneOffset'
    ];
    return DateTime;
}(expression_1.Expression));
exports.DateTime = DateTime;
var Date = /** @class */ (function (_super) {
    __extends(Date, _super);
    function Date(json) {
        var _this = _super.call(this, json) || this;
        _this.json = json;
        return _this;
    }
    Date.prototype.exec = function (ctx) {
        var _a;
        var _this = this;
        for (var _i = 0, _b = Date.PROPERTIES; _i < _b.length; _i++) {
            var property = _b[_i];
            if (this.json[property] != null) {
                // @ts-ignore
                this[property] = (0, builder_1.build)(this.json[property]);
            }
        }
        // @ts-ignore
        var args = Date.PROPERTIES.map(function (p) { return (_this[p] != null ? _this[p].execute(ctx) : undefined); });
        return new ((_a = DT.Date).bind.apply(_a, __spreadArray([void 0], args, false)))();
    };
    Date.PROPERTIES = ['year', 'month', 'day'];
    return Date;
}(expression_1.Expression));
exports.Date = Date;
var Time = /** @class */ (function (_super) {
    __extends(Time, _super);
    function Time(json) {
        var _this = _super.call(this, json) || this;
        for (var _i = 0, _a = Time.PROPERTIES; _i < _a.length; _i++) {
            var property = _a[_i];
            if (json[property] != null) {
                // @ts-ignore
                _this[property] = (0, builder_1.build)(json[property]);
            }
        }
        return _this;
    }
    Time.prototype.exec = function (ctx) {
        var _a;
        var _this = this;
        // @ts-ignore
        var args = Time.PROPERTIES.map(function (p) { return (_this[p] != null ? _this[p].execute(ctx) : undefined); });
        return new ((_a = DT.DateTime).bind.apply(_a, __spreadArray([void 0, 0, 1, 1], args, false)))().getTime();
    };
    Time.PROPERTIES = ['hour', 'minute', 'second', 'millisecond'];
    return Time;
}(expression_1.Expression));
exports.Time = Time;
var Today = /** @class */ (function (_super) {
    __extends(Today, _super);
    function Today(json) {
        return _super.call(this, json) || this;
    }
    Today.prototype.exec = function (ctx) {
        return ctx.getExecutionDateTime().getDate();
    };
    return Today;
}(expression_1.Expression));
exports.Today = Today;
var Now = /** @class */ (function (_super) {
    __extends(Now, _super);
    function Now(json) {
        return _super.call(this, json) || this;
    }
    Now.prototype.exec = function (ctx) {
        return ctx.getExecutionDateTime();
    };
    return Now;
}(expression_1.Expression));
exports.Now = Now;
var TimeOfDay = /** @class */ (function (_super) {
    __extends(TimeOfDay, _super);
    function TimeOfDay(json) {
        return _super.call(this, json) || this;
    }
    TimeOfDay.prototype.exec = function (ctx) {
        return ctx.getExecutionDateTime().getTime();
    };
    return TimeOfDay;
}(expression_1.Expression));
exports.TimeOfDay = TimeOfDay;
var DateTimeComponentFrom = /** @class */ (function (_super) {
    __extends(DateTimeComponentFrom, _super);
    function DateTimeComponentFrom(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    DateTimeComponentFrom.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            return arg[this.precision.toLowerCase()];
        }
        else {
            return null;
        }
    };
    return DateTimeComponentFrom;
}(expression_1.Expression));
exports.DateTimeComponentFrom = DateTimeComponentFrom;
var DateFrom = /** @class */ (function (_super) {
    __extends(DateFrom, _super);
    function DateFrom(json) {
        return _super.call(this, json) || this;
    }
    DateFrom.prototype.exec = function (ctx) {
        var date = this.execArgs(ctx);
        if (date != null) {
            return date.getDate();
        }
        else {
            return null;
        }
    };
    return DateFrom;
}(expression_1.Expression));
exports.DateFrom = DateFrom;
var TimeFrom = /** @class */ (function (_super) {
    __extends(TimeFrom, _super);
    function TimeFrom(json) {
        return _super.call(this, json) || this;
    }
    TimeFrom.prototype.exec = function (ctx) {
        var date = this.execArgs(ctx);
        if (date != null) {
            return date.getTime();
        }
        else {
            return null;
        }
    };
    return TimeFrom;
}(expression_1.Expression));
exports.TimeFrom = TimeFrom;
var TimezoneOffsetFrom = /** @class */ (function (_super) {
    __extends(TimezoneOffsetFrom, _super);
    function TimezoneOffsetFrom(json) {
        return _super.call(this, json) || this;
    }
    TimezoneOffsetFrom.prototype.exec = function (ctx) {
        var date = this.execArgs(ctx);
        if (date != null) {
            return date.timezoneOffset;
        }
        else {
            return null;
        }
    };
    return TimezoneOffsetFrom;
}(expression_1.Expression));
exports.TimezoneOffsetFrom = TimezoneOffsetFrom;
// Delegated to by overloaded#After
function doAfter(a, b, precision) {
    return a.after(b, precision);
}
exports.doAfter = doAfter;
// Delegated to by overloaded#Before
function doBefore(a, b, precision) {
    return a.before(b, precision);
}
exports.doBefore = doBefore;
var DifferenceBetween = /** @class */ (function (_super) {
    __extends(DifferenceBetween, _super);
    function DifferenceBetween(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    DifferenceBetween.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        // Check to make sure args exist and that they have differenceBetween functions so that they can be compared to one another
        if (args[0] == null ||
            args[1] == null ||
            typeof args[0].differenceBetween !== 'function' ||
            typeof args[1].differenceBetween !== 'function') {
            return null;
        }
        var result = args[0].differenceBetween(args[1], this.precision != null ? this.precision.toLowerCase() : undefined);
        if (result != null && result.isPoint()) {
            return result.low;
        }
        else {
            return result;
        }
    };
    return DifferenceBetween;
}(expression_1.Expression));
exports.DifferenceBetween = DifferenceBetween;
var DurationBetween = /** @class */ (function (_super) {
    __extends(DurationBetween, _super);
    function DurationBetween(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    DurationBetween.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        // Check to make sure args exist and that they have durationBetween functions so that they can be compared to one another
        if (args[0] == null ||
            args[1] == null ||
            typeof args[0].durationBetween !== 'function' ||
            typeof args[1].durationBetween !== 'function') {
            return null;
        }
        var result = args[0].durationBetween(args[1], this.precision != null ? this.precision.toLowerCase() : undefined);
        if (result != null && result.isPoint()) {
            return result.low;
        }
        else {
            return result;
        }
    };
    return DurationBetween;
}(expression_1.Expression));
exports.DurationBetween = DurationBetween;
//# sourceMappingURL=datetime.js.map